// ==============================================================================
// BÜROFUCHS GLOBAL DİL SÖZLÜĞÜ (MASTER ENTERPRISE EDITION)
// Kapsam: DE, EN, TR, ES, FR, IT, PL, RU, SA
// Versiyon: 2.0.1 (Fix: Syntax Error Cleaned)
// ==============================================================================

export const languages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'sa', name: 'العربية', flag: '🇸🇦' },
];

export const translations = {
  // 🇩🇪 --- DEUTSCH (ROOT / SYSTEM DEFAULT) ---
  de: {
    // GENERAL
    app_name: 'BüroFuchs',
    system_online: 'SYSTEM ONLINE',
    welcome_morning: 'Guten Morgen',
    welcome_day: 'Guten Tag',
    welcome_evening: 'Guten Abend',
    slogan_hero: 'Deine Bürokratie. Einfach. Digital.',
    copyright: '© 2025 BüroFuchs Digital. Made in Frankfurt.',
    
    // HOMEPAGE
    hero_badge: 'NEU: KI-Steuer 2025',
    hero_title_1: 'Deine Finanzen.',
    hero_title_2: 'Automatisiert.',
    hero_desc: 'BüroFuchs erledigt deine Steuererklärung, Rechnungen und Bürokratie in Deutschland. Sicher, schnell und auf deiner Sprache.',
    cta_start_free: 'Kostenlos Starten',
    cta_signup: 'Anmelden',
    download_apk: 'App Herunterladen',
    ecosystem_title: 'Das Ökosystem',
    ecosystem_desc: 'Eine Plattform für alle deine Bedürfnisse.',
    mod_tax_title: 'Steuererklärung',
    mod_tax_desc: 'Maximale Rückerstattung mit KI-Hilfe. ELSTER integriert.',
    mod_bureaucracy_title: 'Bürokratie',
    mod_bureaucracy_desc: 'Formulare automatisch ausfüllen (Anmeldung, Kindergeld).',
    mod_invoice_title: 'Rechnungen',
    mod_invoice_desc: 'Professionelle Rechnungen in Sekunden erstellen.',
    mod_vault_title: 'Digitaler Tresor',
    mod_vault_desc: 'Alle Dokumente sicher und verschlüsselt an einem Ort.',
    mod_lang_title: 'Mehrsprachig',
    mod_lang_desc: 'Verstehe deutsche Bürokratie in deiner Muttersprache.',
    why_us_title: 'Warum BüroFuchs?',
    why_us_desc: 'Der Vergleich spricht für sich.',
    feat_tax_refund: 'Steuerrückerstattung',
    feat_bureaucracy: 'Behördengänge',
    feat_invoice: 'Rechnungstool',
    feat_salary: 'Gehaltsanalyse',
    feat_native_lang: 'Muttersprache',
    feat_archive: 'Digitales Archiv',
    price_title: 'Preise',
    plan_starter: 'STARTER',
    plan_pro: 'PRO',
    price_pay_submit: 'Zahlen bei Abgabe',
    btn_try_free: 'Kostenlos Testen',

    // MENÜ
    menu_dashboard: 'Dashboard',
    menu_archive: 'Digitales Archiv',
    menu_create_invoice: 'Rechnung erstellen',
    menu_templates: 'Brief-Assistent',
    menu_salary: 'Gehaltsrechner',
    menu_academy: 'Akademie',
    menu_procedures: 'Behördengänge',
    menu_profile: 'Mein Profil',
    menu_settings: 'Einstellungen',
    menu_logout: 'Abmelden',
    menu_quick_scan: 'Quick Scan',
    digital_hub: 'Digital Hub',

    // SIDEBAR & GAMIFICATION
    main_control: 'Hauptsteuerung',
    security_clearance: 'Sicherheitsstufe',
    commander: 'Kommandant',
    cadet_level: 'Kadett Level 1',
    unlimited: 'Unbegrenzt',
    limited_access: 'Begrenzter Zugang',
    upgrade: 'Upgrade',

    // DASHBOARD & KPI
    total_expenses: 'GESAMTAUSGABEN',
    refund_potential: 'RÜCKERSTATTUNG',
    total_documents: 'DOKUMENTE',
    ai_efficiency: 'AI EFFIZIENZ',
    live_feed: 'LIVE FEED',
    view_all_documents: 'ALLE ANZEIGEN',
    recent_vault: 'LETZTE EINTRÄGE',
    quick_terminal: 'SCHNELL TERMINAL',
    smart_scan: 'SMART SCAN',
    invoice: 'Rechnung',
    drafts: 'Entwürfe',
    
    // ONBOARDING WIZARD
    setup_title: 'Willkommen!',
    setup_subtitle: 'Lass uns dein Profil einrichten.',
    freelancer: 'FREELANCER',
    company: 'GMBH / UG',
    firm_data: 'FIRMENDATEN',
    continue: 'WEITER',
    almost_done: 'FAST GESCHAFFT',
    ready_start: 'BEREIT ZUM START!',
    enter_dashboard: 'DASHBOARD BETRETEN',
    iban_placeholder: 'IBAN für deine Rechnungen',
    
    // SCAN MODAL
    initiate_scan: 'Scan Starten',
    release_to_scan: 'Loslassen zum Scannen',
    scan_modal_desc: 'Laden Sie Dokumente für die automatische KI-Analyse hoch.',
    camera_capture: 'Kamera',
    upload_from_device: 'Datei Auswählen',
    scan_step_1: 'Initialisiere Neurale Module...',
    scan_step_2: 'OCR-Schicht Extraktion...',
    scan_step_3: 'Daten & Währung Parsen...',
    scan_step_4: 'Dokument Kategorisieren...',
    scan_step_5: 'Verschlüsseln für den Tresor...',
    scan_step_6: 'Ergebnisse Finalisieren...',
    scan_success: 'Analyse Abgeschlossen',
    scan_success_desc: 'Dokument erfolgreich verarbeitet.',
    scan_error: 'Verbindung Fehlgeschlagen',
    error_file_large: 'Datei zu groß',
    ai_active: 'KI: Aktiv',
    ready_to_scan: 'Bereit zum Scannen',
    ai_analyzing: 'KI Analysiert',

    // PREMIUM MODAL
    prem_hint_2: 'Werde ein Elite-Fuchs!',
    plan_free_title: 'KOSTENLOS',
    plan_free_subtitle: 'Für Einsteiger',
    plan_standard_title: 'STANDARD',
    plan_standard_subtitle: 'Für Ambitionierte',
    plan_pro_title: 'PRO ELITE',
    plan_pro_subtitle: 'Für Profis & Firmen',
    period_forever: 'Dauerhaft',
    period_month: '/ Monat',
    period_year: '/ Jahr',
    monthly: 'MONATLICH',
    yearly: 'JÄHRLICH',
    select_plan: 'Plan Wählen',
    feat_3_docs: '3 Dokumente / Monat',
    feat_basic_archive: 'Basis-Archiv',
    feat_ads: 'Mit Werbung',
    feat_unlimited: 'Unbegrenzte Dokumente',
    feat_risk_radar: 'KI Risiko-Radar',
    feat_templates: 'Alle Vorlagen',
    feat_no_ads: 'Keine Werbung',
    feat_all_included: 'Alles aus Standard',
    feat_datev: 'DATEV Export',
    feat_invoice_tool: 'Rechnungs-Tool',
    feat_priority: 'Priorisierter Support',

    // FOX CHAT
    chat_system_online: 'Systeme Online.',
    chat_welcome: 'Hallo {name}! Bereit, Ihre Finanzdaten zu analysieren. Was möchten Sie wissen?',
    chat_default_greeting: 'Meine Intelligenz steht Ihnen zur Verfügung. Wie kann ich helfen?',
    chat_placeholder: 'Frag den Fuchs...',
    chat_connection_error: 'Verbindung unterbrochen.',
    chat_retry: 'Bitte versuchen Sie es erneut.',
    chat_neural_link: 'NEURAL LINK: AKTIV',
    chat_fox_intelligence: 'Fox Intelligenz',

    // TAX INSIGHT CARD
    analysis_title: 'FoxRadar Analyse',
    neural_engine: 'Neurale Engine Bereitgestellt',
    status_deductible: 'Steuerlich Absetzbar',
    status_non_deductible: 'Nicht Absetzbar',
    risk_critical: 'KRITISCHES RISIKO',
    risk_moderate: 'MODERATES RISIKO',
    risk_secure: 'SICHER / VERIFIZIERT',
    risk_no_issues: 'Keine Compliance-Probleme erkannt. Sicher zu archivieren.',
    label_category: 'Erkannte Kategorie',
    category_general: 'Allgemeine Ausgabe',
    label_score: 'Absetzbarkeits-Score',
    label_strategic: 'Strategischer Hinweis',
    default_tip: 'Dokumentintegrität verifiziert. Bereit zur Archivierung.',
    encrypted_analysis: 'E2EE Verschlüsselte Analyse',

    // TRUST BAR
    trust_datacenter_title: 'INFRASTRUKTUR',
    trust_privacy_title: 'SICHERHEITSPROTOKOLL',
    trust_origin_title: 'ENGINEERING',

    // LEGAL DISCLAIMER
    legal_disclaimer_title: 'Rechtlicher Hinweis',
    legal_disclaimer_subtitle: 'Compliance & Beratung',
    legal_disclaimer_important: 'Wichtiger Hinweis',
    legal_disclaimer_warning: 'BüroFuchs ist ein KI-gestützter Assistent und kein Ersatz für professionelle steuerliche oder rechtliche Beratung.',
    legal_disclaimer_main: 'BüroFuchs nutzt modernste KI-Modelle (Gemini 2.0 Pro), um komplexe deutsche Behördenangelegenheiten zu visualisieren und zu vereinfachen.',
    legal_disclaimer_point_1: 'Alle generierten Dokumente und Informationen dienen nur zu Informationszwecken.',
    legal_disclaimer_point_2: 'Wir übernehmen keine Haftung für die Richtigkeit, Vollständigkeit oder Aktualität der bereitgestellten Daten.',
    legal_disclaimer_point_3: 'Konsultieren Sie bei rechtlichen oder steuerlichen Fragen immer einen qualifizierten Fachmann.',
    legal_scroll_unlock: 'Scrollen zum Entsperren',
    legal_accept: 'Akzeptieren & Fortfahren',
    legal_read_continue: 'Zum Fortfahren lesen',

    // FOX MASCOT
    fox_take_action: 'Aktion ausführen',
    fox_examine: 'Prüfen',
    fox_hint_scan: 'Tippen Sie hier für einen Schnellscan!',
    fox_hint_chat: 'Ich bin hier, um zu helfen!',
    fox_hint_premium: 'Upgrade auf Pro für mehr Funktionen.',

    // TIMELINE
    timeline_title: 'Zeitachse',
    recent_activity: 'Letzte Aktivitäten',
    total_documents: 'Gesamt',
    no_documents_yet: 'Noch keine Dokumente',
    system_clean: 'System sauber. Starten Sie FoxRadar mit einem neuen Dokument.',
    status_paid: 'Bezahlt',
    status_unpaid: 'Offen',
    status_urgent: 'Dringend',
    untitled_doc: 'Unbenanntes Dokument',

    // TAX CALCULATOR
    tax_calc_title: 'Netto Rechner',
    tax_calc_desc: 'Optimierte Gehaltssimulation basierend auf BMF-Daten 2024.',
    gross_income: 'Bruttoeinkommen (Jahresgehalt)',
    tax_class: 'Steuerklasse',
    tax_class_info: 'Klassen-Guide',
    tax_class_desc: 'Klasse 1 für Singles, Klasse 3 für Verheiratete mit höherem Einkommen empfohlen.',
    monthly_net: 'Monatliches Netto',
    yearly_net: 'Netto / Jahr',
    yearly_tax: 'Steuer / Jahr',
    start_pro_analysis: 'Pro-Analyse Starten',
    live_calc: 'Live Rechner 2024',

    // DATEV EXPORT
    datev_uplink: 'DATEV Schnittstelle',
    datev_ready: 'Bereit',
    datev_desc: 'Verschlüsselt Ihre Finanzdaten nach deutschen Buchhaltungsstandards (DATEV XML).',
    btn_initiate_export: 'Export Starten',
    btn_compiling: 'Daten werden kompiliert...',
    btn_export_complete: 'Export Abgeschlossen',
    btn_retry_uplink: 'Uplink Wiederholen',
    datev_format: 'Format: DATEV XML 7.0',
    e2ee_encrypted: 'E2EE Verschlüsseltes Paket',

    // COOKIE CONSENT
    cookie_title: 'Sichere Verbindung',
    cookie_desc: 'Datenschutz ist unsere Priorität. Wir verwenden AES-256-Verschlüsselung und sichere Cookies auf unseren Servern in Frankfurt.',
    cookie_accept: 'Protokoll Akzeptieren',
    cookie_essential: 'Nur Notwendige',
    cookie_badge: 'DSGVO Konform',

    // TEMPLATES
    docu_title: 'Dokumenten-Generator',
    choose_process: 'Wählen Sie Ihren',
    choose_process_desc: 'Rechtssicher. DIN-5008 Konform. Sofort Download.',
    start_protocol: 'Protokoll Starten',
    tpl_termination: 'Kündigung',
    tpl_termination_desc: 'Vertragskündigung (Mobilfunk, Fitness, Miete) rechtssicher erstellen.',
    tpl_objection: 'Widerspruch',
    tpl_objection_desc: 'Einspruch gegen Bescheide oder Rechnungen einlegen.',
    tpl_relocation: 'Adressänderung',
    tpl_relocation_desc: 'Offizielle Mitteilung über Umzug an Behörden und Firmen.',
    full_name: 'Vollständiger Name',
    address: 'Adresse',
    recipient_label: 'Empfänger',
    recipient_placeholder: 'z.B. Vodafone GmbH',
    customer_no: 'Kundennummer',
    date: 'Datum',
    signature: 'Unterschrift',
    clear: 'Löschen',
    waiting_input: 'Warte auf Eingabe...',
    send_mail: 'E-Mail & Download',

    // EMAIL VERIFICATION
    verify_checking: 'E-Mail wird überprüft...',
    verify_title: 'Wird verifiziert',
    verify_subtitle: 'BüroFuchs überprüft Ihre Identität auf unseren sicheren Servern...',
    verify_success_title: 'Willkommen an Bord,',
    verify_success_title_span: 'Captain!',
    verify_success_msg: 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt. Sie haben jetzt vollen Zugriff.',
    verify_error_title: 'Ein Problem ist aufgetreten',
    verify_error_msg_default: 'Der Link ist abgelaufen oder wurde bereits verwendet.',
    verify_missing_token: 'Verifizierungsschlüssel fehlt oder ist ungültig.',
    verify_complete_badge: 'Verifizierung abgeschlossen',
    btn_go_dashboard: 'ZUM DASHBOARD',
    btn_return_home: 'ZUR STARTSEITE',
    security_protocol: 'BüroFuchs Sicherheitsprotokoll v4.0',

    // DOCUMENT EDITOR
    editor_title: 'Editor Terminal',
    editor_subtitle: 'Intelligenz-Modul v4.0',
    btn_initiate_ai: 'KI Auto-Fill Starten',
    btn_processing_ai: 'Neurales Netzwerk verarbeitet...',
    ai_summary_title: 'KI Intelligente Zusammenfassung',
    risk_detected: 'Risiko Erkannt',
    no_critical_risks: 'Keine Kritischen Risiken',
    ai_success_toast: 'KI-Analyse Abgeschlossen',
    ai_success_desc: 'Daten wurden intelligent zugeordnet.',
    ai_error_toast: 'Analyse Fehlgeschlagen',
    ai_error_desc: 'KI-Server ist derzeit ausgelastet.',
    label_merchant: 'Händler / Titel',
    label_amount: 'Betrag (€)',
    label_category: 'Kategorie',
    label_date: 'Datum',
    label_due_date: 'Fälligkeitsdatum',
    label_notes: 'Detaillierte Notizen',
    placeholder_notes: 'Fügen Sie hier Notizen hinzu...',
    btn_cancel: 'Abbrechen',
    btn_save_intelligence: 'Intelligenz Speichern',
    btn_saving: 'Speichern...',
    category_tax: 'Steuern',
    category_insurance: 'Versicherung',
    category_housing: 'Wohnen',
    category_car: 'KFZ',
    category_office: 'Büro',
    category_communication: 'Kommunikation',
    category_travel: 'Reise',
    category_advertising: 'Werbung',
    category_legal: 'Recht',
    category_finance: 'Finanzen',
    category_other: 'Sonstiges',

    // FOOTER
    footer_desc: 'Ihr KI-gestütztes Dashboard für finanzielle Freiheit in Deutschland. Sicher, Schnell, Intelligent.',
    footer_platform: 'Plattform',
    footer_resources: 'Ressourcen',
    footer_company: 'Unternehmen',
    footer_legal: 'Rechtliches & Datenschutz',
    footer_impressum: 'Impressum',
    footer_settings: 'Einstellungen & Abo',
    made_with_love: 'Made with❤️ in Frankfurt.',
    server_loc: 'Serverstandort: Frankfurt (AWS EU-Central-1)',
    gdpr_compliant: 'DSGVO Konform',

    // AUTH
    welcome_title: 'Willkommen bei',
    future_work: 'Die Zukunft der Arbeit.',
    auth_desc: 'Verwalten Sie alle Ihre bürokratischen und finanziellen Prozesse in Deutschland von einem intelligenten Zentrum aus.',
    welcome_back: 'Willkommen zurück',
    create_account: 'Konto erstellen',
    login_subtitle: 'Geben Sie Ihre Anmeldedaten ein, um auf Ihren Tresor zuzugreifen.',
    register_subtitle: 'Starten Sie Ihre Reise mit einem kostenlosen Konto.',
    label_fullname: 'Vollständiger Name',
    label_email: 'E-Mail-Adresse',
    label_password: 'Passwort',
    forgot_password: 'Vergessen?',
    btn_signin: 'Anmelden',
    btn_signup: 'Registrieren',
    btn_processing: 'Verarbeitung...',
    or_continue: 'Oder weiter mit',
    no_account: 'Noch kein Konto?',
    have_account: 'Bereits ein Konto?',
    toast_welcome_back: 'Willkommen zurück',
    toast_login_success: 'Erfolgreich angemeldet, Weiterleitung...',
    toast_register_success: 'Registrierung erfolgreich',
    toast_failed: 'Vorgang fehlgeschlagen',
    toast_google_success: 'Google Login erfolgreich',
    toast_google_failed: 'Anmeldung fehlgeschlagen',

    // OFFICIAL PROCEDURES
    official_procedures: 'Verfügbare Prozesse',
    search_procedures: 'Prozedur suchen...',
    fox_bureau_subtitle: 'Dein digitaler Behörden-Assistent.',
    ai_is_fast: 'KI ist schneller',
    traditional: 'Traditionell',
    slow: 'Langsam',
    fast: 'Schnell',
    popular_badge: 'Beliebt',
    automated: 'Automatisiert',
    start_process: 'Prozess Starten',
    
    // TABS
    tab_all: 'Alle',
    tab_relocation: 'Umzug',
    tab_family: 'Familie',
    tab_visa: 'Visum',
    tab_vehicle: 'KFZ',
    tab_business: 'Gewerbe',
    
    // PROCEDURES DETAILED
    proc_anmeldung_title: 'Wohnsitzanmeldung',
    proc_anmeldung_sub: 'Bürgeramt Anmeldung',
    proc_anmeldung_desc: 'Offizielle Anmeldung deiner Adresse beim Bürgeramt. Pflicht innerhalb von 2 Wochen.',
    proc_kindergeld_title: 'Kindergeld',
    proc_kindergeld_sub: 'Familienkasse',
    proc_kindergeld_desc: 'Beantrage staatliche Unterstützung für deine Kinder (250€ pro Kind).',
    proc_bluecard_title: 'Blaue Karte EU',
    proc_bluecard_sub: 'Arbeitsvisum',
    proc_bluecard_desc: 'Aufenthaltstitel für akademische Fachkräfte aus Nicht-EU-Staaten.',
    proc_kfz_title: 'KFZ-Zulassung',
    proc_kfz_sub: 'Fahrzeug anmelden',
    proc_kfz_desc: 'Auto anmelden, ummelden oder abmelden ohne Wartezeit.',
    proc_gewerbe_title: 'Gewerbeanmeldung',
    proc_gewerbe_sub: 'Selbstständigkeit',
    proc_gewerbe_desc: 'Offizielle Registrierung deines Unternehmens oder Kleingewerbes.',
  },

  // 🇬🇧 --- ENGLISH ---
  en: {
    app_name: 'BüroFuchs',
    system_online: 'SYSTEM ONLINE',
    welcome_morning: 'Good Morning',
    welcome_day: 'Good Afternoon',
    welcome_evening: 'Good Evening',
    slogan_hero: 'Your Bureaucracy. Simple. Digital.',
    copyright: '© 2025 BüroFuchs Digital. Made in Frankfurt.',
    hero_badge: 'NEW: AI Tax 2025',
    hero_title_1: 'Your Finances.',
    hero_title_2: 'Automated.',
    hero_desc: 'BüroFuchs handles your tax returns, invoices, and bureaucracy in Germany. Secure, fast, and in your language.',
    cta_start_free: 'Start for Free',
    cta_signup: 'Sign Up',
    download_apk: 'Download App',
    ecosystem_title: 'The Ecosystem',
    ecosystem_desc: 'One platform for all your needs.',
    mod_tax_title: 'Tax Declaration',
    mod_tax_desc: 'Maximum refund with AI assistance. ELSTER integrated.',
    mod_bureaucracy_title: 'Bureaucracy',
    mod_bureaucracy_desc: 'Auto-fill forms (Registration, Child Benefits).',
    mod_invoice_title: 'Invoicing',
    mod_invoice_desc: 'Create professional invoices in seconds.',
    mod_vault_title: 'Digital Vault',
    mod_vault_desc: 'All documents secure and encrypted in one place.',
    mod_lang_title: 'Multi-language',
    mod_lang_desc: 'Understand German bureaucracy in your native language.',
    why_us_title: 'Why BüroFuchs?',
    why_us_desc: 'The comparison speaks for itself.',
    feat_tax_refund: 'Tax Refund',
    feat_bureaucracy: 'Bureaucracy',
    feat_invoice: 'Invoice Tool',
    feat_salary: 'Salary Analysis',
    feat_native_lang: 'Native Language',
    feat_archive: 'Digital Archive',
    price_title: 'Pricing',
    plan_starter: 'STARTER',
    plan_pro: 'PRO',
    price_pay_submit: 'Pay on Submission',
    btn_try_free: 'Try for Free',
    menu_dashboard: 'Dashboard',
    menu_archive: 'Digital Archive',
    menu_create_invoice: 'Create Invoice',
    menu_templates: 'Letter Assistant',
    menu_salary: 'Salary Calculator',
    menu_academy: 'Academy',
    menu_procedures: 'Official Procedures',
    menu_profile: 'My Profile',
    menu_settings: 'Settings',
    menu_logout: 'Logout',
    menu_quick_scan: 'Quick Scan',
    digital_hub: 'Digital Hub',
    main_control: 'Main Control',
    security_clearance: 'Security Clearance',
    commander: 'Commander',
    cadet_level: 'Cadet Level 1',
    unlimited: 'Unlimited',
    limited_access: 'Limited Access',
    upgrade: 'Upgrade',
    total_expenses: 'TOTAL EXPENSES',
    refund_potential: 'REFUND POTENTIAL',
    total_documents: 'DOCUMENTS',
    ai_efficiency: 'AI EFFICIENCY',
    live_feed: 'LIVE FEED',
    view_all_documents: 'VIEW ALL',
    recent_vault: 'RECENT VAULT',
    quick_terminal: 'QUICK TERMINAL',
    smart_scan: 'SMART SCAN',
    invoice: 'Invoice',
    drafts: 'Drafts',
    setup_title: 'Welcome!',
    setup_subtitle: 'Let\'s set up your profile.',
    freelancer: 'FREELANCER',
    company: 'COMPANY',
    firm_data: 'COMPANY DATA',
    continue: 'CONTINUE',
    almost_done: 'ALMOST DONE',
    ready_start: 'READY TO START!',
    enter_dashboard: 'ENTER DASHBOARD',
    iban_placeholder: 'IBAN for your invoices',
    initiate_scan: 'Initiate Scan',
    release_to_scan: 'Release to Scan',
    scan_modal_desc: 'Upload documents for automated AI analysis.',
    camera_capture: 'Camera',
    upload_from_device: 'Select File',
    scan_step_1: 'Initializing Neural Modules...',
    scan_step_2: 'OCR Layer Extraction...',
    scan_step_3: 'Parsing Dates & Currency...',
    scan_step_4: 'Categorizing Document...',
    scan_step_5: 'Encrypting for Vault...',
    scan_step_6: 'Finalizing Results...',
    scan_success: 'Analysis Complete',
    scan_success_desc: 'Document processed successfully.',
    scan_error: 'Connection Failed',
    error_file_large: 'File Too Large',
    ai_active: 'AI: Active',
    ready_to_scan: 'Ready to Scan',
    ai_analyzing: 'AI Analyzing',
    prem_hint_2: 'Become an Elite Fox!',
    plan_free_title: 'FREE',
    plan_free_subtitle: 'For Beginners',
    plan_standard_title: 'STANDARD',
    plan_standard_subtitle: 'For Ambitious Users',
    plan_pro_title: 'PRO ELITE',
    plan_pro_subtitle: 'For Pros & Companies',
    period_forever: 'Forever',
    period_month: '/ Month',
    period_year: '/ Year',
    monthly: 'MONTHLY',
    yearly: 'YEARLY',
    select_plan: 'Select Plan',
    feat_3_docs: '3 Docs / Month',
    feat_basic_archive: 'Basic Archive',
    feat_ads: 'Ad-Supported',
    feat_unlimited: 'Unlimited Docs',
    feat_risk_radar: 'AI Risk Radar',
    feat_templates: 'All Templates',
    feat_no_ads: 'Ad-Free',
    feat_all_included: 'All from Standard',
    feat_datev: 'DATEV Export',
    feat_invoice_tool: 'Invoice Tool',
    feat_priority: 'Priority Support',
    chat_system_online: 'Systems Online.',
    chat_welcome: 'Hello {name}! Ready to analyze your financial data. What would you like to know?',
    chat_default_greeting: 'My intelligence is at your service. How can I assist?',
    chat_placeholder: 'Ask the Fox...',
    chat_connection_error: 'Connection interrupted.',
    chat_retry: 'Please try again.',
    chat_neural_link: 'NEURAL LINK: ACTIVE',
    chat_fox_intelligence: 'Fox Intelligence',
    analysis_title: 'FoxRadar Analysis',
    neural_engine: 'Neural Engine Deployed',
    status_deductible: 'Tax Deductible',
    status_non_deductible: 'Non-Deductible',
    risk_critical: 'CRITICAL RISK',
    risk_moderate: 'MODERATE RISK',
    risk_secure: 'SECURE / VERIFIED',
    risk_no_issues: 'No compliance issues detected. Safe to archive.',
    label_category: 'Detected Category',
    category_general: 'General Expense',
    label_score: 'Deductibility Score',
    label_strategic: 'Strategic Advice',
    default_tip: 'Document integrity verified. Ready for archiving.',
    encrypted_analysis: 'E2EE Encrypted Analysis',
    trust_datacenter_title: 'INFRASTRUCTURE',
    trust_privacy_title: 'SECURITY PROTOCOL',
    trust_origin_title: 'ENGINEERING',
    legal_disclaimer_title: 'Legal Disclaimer',
    legal_disclaimer_subtitle: 'Compliance & Advisory',
    legal_disclaimer_important: 'Important Notice',
    legal_disclaimer_warning: 'BüroFuchs is an AI-powered assistant and not a substitute for professional tax or legal advice.',
    legal_disclaimer_main: 'BüroFuchs uses state-of-the-art AI models (Gemini 2.0 Pro) to visualize and simplify complex German bureaucratic matters.',
    legal_disclaimer_point_1: 'All generated documents and information are for informational purposes only.',
    legal_disclaimer_point_2: 'We assume no liability for the accuracy, completeness, or timeliness of the data provided.',
    legal_disclaimer_point_3: 'Always consult a qualified professional for legal or tax questions.',
    legal_scroll_unlock: 'Scroll to unlock',
    legal_accept: 'Accept & Proceed',
    legal_read_continue: 'Read to Continue',
    fox_take_action: 'Take Action',
    fox_examine: 'Examine',
    fox_hint_scan: 'Tap here for a quick scan!',
    fox_hint_chat: 'I am here to help!',
    fox_hint_premium: 'Upgrade to Pro for more features.',
    timeline_title: 'TimeLine',
    recent_activity: 'Recent Activity',
    total_documents: 'Total',
    no_documents_yet: 'No Documents Yet',
    system_clean: 'System clean. Initiate FoxRadar with a new document.',
    status_paid: 'Paid',
    status_unpaid: 'Unpaid',
    status_urgent: 'Urgent',
    untitled_doc: 'Untitled Document',
    tax_calc_title: 'Net Salary Calculator',
    tax_calc_desc: 'Optimized salary simulation based on 2024 BMF data.',
    gross_income: 'Gross Income (Annual)',
    tax_class: 'Tax Class',
    tax_class_info: 'Class Guide',
    tax_class_desc: 'Class 1 for singles, Class 3 recommended for higher-earning spouses.',
    monthly_net: 'Monthly Net',
    yearly_net: 'Net / Year',
    yearly_tax: 'Tax / Year',
    start_pro_analysis: 'Start Pro Analysis',
    live_calc: 'Live Calculator 2024',
    datev_uplink: 'DATEV Uplink',
    datev_ready: 'Ready',
    datev_desc: 'Encrypts and packages your financial data according to German accounting standards (DATEV XML).',
    btn_initiate_export: 'Initiate Export',
    btn_compiling: 'Compiling Data...',
    btn_export_complete: 'Export Complete',
    btn_retry_uplink: 'Retry Uplink',
    datev_format: 'Format: DATEV XML 7.0',
    e2ee_encrypted: 'E2EE Encrypted Package',
    cookie_title: 'Secure Connection',
    cookie_desc: 'Data privacy is our priority. We use AES-256 encryption and secure cookies on our Frankfurt servers.',
    cookie_accept: 'Accept Protocol',
    cookie_essential: 'Essential Only',
    cookie_badge: 'GDPR Compliant',
    docu_title: 'Document Generator',
    choose_process: 'Select Your',
    choose_process_desc: 'Legally compliant. DIN-5008 Standard. Instant Download.',
    start_protocol: 'Start Protocol',
    tpl_termination: 'Termination',
    tpl_termination_desc: 'Create legally secure termination letters (Mobile, Gym, Rent).',
    tpl_objection: 'Objection',
    tpl_objection_desc: 'File an objection against decisions or invoices.',
    tpl_relocation: 'Change of Address',
    tpl_relocation_desc: 'Official notification of move to authorities and companies.',
    full_name: 'Full Name',
    address: 'Address',
    recipient_label: 'Recipient',
    recipient_placeholder: 'e.g. Vodafone GmbH',
    customer_no: 'Customer No.',
    date: 'Date',
    signature: 'Signature',
    clear: 'Clear',
    waiting_input: 'Waiting for Input...',
    send_mail: 'Email & Download',
    verify_checking: 'Checking email...',
    verify_title: 'Verifying',
    verify_subtitle: 'BüroFuchs is verifying your identity on our secure servers...',
    verify_success_title: 'Welcome Aboard,',
    verify_success_title_span: 'Captain!',
    verify_success_msg: 'Your email address has been successfully verified. You now have full access.',
    verify_error_title: 'Something went wrong',
    verify_error_msg_default: 'Link expired or already used.',
    verify_missing_token: 'Verification token missing or invalid.',
    verify_complete_badge: 'Verification Complete',
    btn_go_dashboard: 'GO TO DASHBOARD',
    btn_return_home: 'RETURN HOME',
    security_protocol: 'BüroFuchs Security Protocol v4.0',
    editor_title: 'Editor Terminal',
    editor_subtitle: 'Intelligence Module v4.0',
    btn_initiate_ai: 'Initiate AI Auto-Fill',
    btn_processing_ai: 'Processing Neural Network...',
    ai_summary_title: 'AI Intelligent Summary',
    risk_detected: 'Risk Detected',
    no_critical_risks: 'No Critical Risks',
    ai_success_toast: 'AI Analysis Complete',
    ai_success_desc: 'Data matched with intelligent algorithms.',
    ai_error_toast: 'Analysis Failed',
    ai_error_desc: 'AI server is currently busy.',
    label_merchant: 'Merchant / Title',
    label_amount: 'Amount (€)',
    label_category: 'Category',
    label_date: 'Date',
    label_due_date: 'Due Date',
    label_notes: 'Detailed Notes',
    placeholder_notes: 'Add notes here...',
    btn_cancel: 'Cancel',
    btn_save_intelligence: 'Save Intelligence',
    btn_saving: 'Saving...',
    category_tax: 'Tax',
    category_insurance: 'Insurance',
    category_housing: 'Housing',
    category_car: 'Car',
    category_office: 'Office',
    category_communication: 'Communication',
    category_travel: 'Travel',
    category_advertising: 'Advertising',
    category_legal: 'Legal',
    category_finance: 'Finance',
    category_other: 'Other',
    footer_desc: 'Your AI-powered dashboard for financial freedom in Germany. Secure, Fast, Intelligent.',
    footer_platform: 'Platform',
    footer_resources: 'Resources',
    footer_company: 'Company',
    footer_legal: 'Legal & Privacy',
    footer_impressum: 'Imprint',
    footer_settings: 'Settings & Subscription',
    made_with_love: 'Made with ❤️ in Frankfurt.',
    server_loc: 'Server Location: Frankfurt (AWS EU-Central-1)',
    gdpr_compliant: 'GDPR Compliant',
    welcome_title: 'Welcome to',
    future_work: 'The Future of Work.',
    auth_desc: 'Manage all your bureaucratic and financial processes in Germany from a single intelligent hub.',
    welcome_back: 'Welcome Back',
    create_account: 'Create Account',
    login_subtitle: 'Enter your credentials to access your vault.',
    register_subtitle: 'Start your journey with a free account.',
    label_fullname: 'Full Name',
    label_email: 'Email Address',
    label_password: 'Password',
    forgot_password: 'Forgot?',
    btn_signin: 'Sign In',
    btn_signup: 'Sign Up',
    btn_processing: 'Processing...',
    or_continue: 'Or continue with',
    no_account: "Don't have an account?",
    have_account: 'Already have an account?',
    toast_welcome_back: 'Welcome Back',
    toast_login_success: 'Successfully logged in, redirecting...',
    toast_register_success: 'Registration Successful',
    toast_failed: 'Operation Failed',
    toast_google_success: 'Google Login Successful',
    toast_google_failed: 'Login Failed',
    official_procedures: 'Available Procedures',
    search_procedures: 'Search procedure...',
    fox_bureau_subtitle: 'Your digital administrative assistant.',
    ai_is_fast: 'AI is faster',
    traditional: 'Traditional',
    slow: 'Slow',
    fast: 'Fast',
    popular_badge: 'Popular',
    automated: 'Automated',
    start_process: 'Start Process',
    tab_all: 'All',
    tab_relocation: 'Relocation',
    tab_family: 'Family',
    tab_visa: 'Visa',
    tab_vehicle: 'Vehicle',
    tab_business: 'Business',
    proc_anmeldung_title: 'Residence Registration',
    proc_anmeldung_sub: 'Bürgeramt',
    proc_anmeldung_desc: 'Official address registration. Mandatory within 2 weeks.',
    proc_kindergeld_title: 'Child Benefits',
    proc_kindergeld_sub: 'Familienkasse',
    proc_kindergeld_desc: 'Apply for government support for your children (€250 per child).',
    proc_bluecard_title: 'EU Blue Card',
    proc_bluecard_sub: 'Work Visa',
    proc_bluecard_desc: 'Residence permit for academic professionals from non-EU countries.',
    proc_kfz_title: 'Vehicle Registration',
    proc_kfz_sub: 'KFZ-Zulassung',
    proc_kfz_desc: 'Register or re-register your car without the wait.',
    proc_gewerbe_title: 'Trade Registration',
    proc_gewerbe_sub: 'Gewerbeanmeldung',
    proc_gewerbe_desc: 'Official registration of your business or trade.',
  },

  // 🇹🇷 --- TÜRKÇE ---
  tr: {
    app_name: 'BüroFuchs',
    system_online: 'SİSTEM ÇEVRİMİÇİ',
    welcome_morning: 'Günaydın',
    welcome_day: 'Tünaydın',
    welcome_evening: 'İyi Akşamlar',
    slogan_hero: 'Bürokrasiniz. Basit. Dijital.',
    copyright: '© 2025 BüroFuchs Digital. Frankfurt\'ta üretildi.',
    hero_badge: 'YENİ: YZ Vergi 2025',
    hero_title_1: 'Finansal Özgürlük.',
    hero_title_2: 'Otomatikleşti.',
    hero_desc: 'BüroFuchs, Almanya\'daki vergi beyannamenizi, faturalarınızı ve bürokratik işlemlerinizi halleder. Güvenli, hızlı ve kendi dilinizde.',
    cta_start_free: 'Ücretsiz Başla',
    cta_signup: 'Kayıt Ol',
    download_apk: 'Uygulamayı İndir',
    ecosystem_title: 'Ekosistem',
    ecosystem_desc: 'Tüm ihtiyaçlarınız için tek platform.',
    mod_tax_title: 'Vergi Beyannamesi',
    mod_tax_desc: 'Yapay zeka ile maksimum iade. ELSTER entegreli.',
    mod_bureaucracy_title: 'Bürokrasi',
    mod_bureaucracy_desc: 'Formları otomatik doldurun (İkamet, Çocuk Parası).',
    mod_invoice_title: 'Fatura',
    mod_invoice_desc: 'Saniyeler içinde profesyonel faturalar oluşturun.',
    mod_vault_title: 'Dijital Kasa',
    mod_vault_desc: 'Tüm belgeleriniz tek bir yerde, şifreli ve güvende.',
    mod_lang_title: 'Çoklu Dil',
    mod_lang_desc: 'Alman bürokrasisini ana dilinizde anlayın.',
    why_us_title: 'Neden BüroFuchs?',
    why_us_desc: 'Karşılaştırma her şeyi anlatıyor.',
    feat_tax_refund: 'Vergi İadesi',
    feat_bureaucracy: 'Resmi İşlemler',
    feat_invoice: 'Fatura Aracı',
    feat_salary: 'Maaş Analizi',
    feat_native_lang: 'Ana Dil Desteği',
    feat_archive: 'Dijital Arşiv',
    price_title: 'Fiyatlandırma',
    plan_starter: 'BAŞLANGIÇ',
    plan_pro: 'PRO',
    price_pay_submit: 'Gönderince Öde',
    btn_try_free: 'Ücretsiz Dene',
    menu_dashboard: 'Panel',
    menu_archive: 'Dijital Arşiv',
    menu_create_invoice: 'Fatura Kes',
    menu_templates: 'Dilekçe Asistanı',
    menu_salary: 'Maaş Hesapla',
    menu_academy: 'Akademi',
    menu_procedures: 'Resmi İşlemler',
    menu_profile: 'Profilim',
    menu_settings: 'Ayarlar',
    menu_logout: 'Çıkış Yap',
    menu_quick_scan: 'Hızlı Tara',
    digital_hub: 'DİJİTAL MERKEZ',
    main_control: 'Ana Kontrol',
    security_clearance: 'Güvenlik Yetkisi',
    commander: 'Komutan',
    cadet_level: 'Kadett Seviye 1',
    unlimited: 'Sınırsız',
    limited_access: 'Kısıtlı Erişim',
    upgrade: 'Yükselt',
    total_expenses: 'TOPLAM GİDER',
    refund_potential: 'İADE POTANSİYELİ',
    total_documents: 'BELGE SAYISI',
    ai_efficiency: 'AI VERİMLİLİĞİ',
    live_feed: 'CANLI AKIŞ',
    view_all_documents: 'TÜMÜNÜ GÖR',
    recent_vault: 'SON KAYITLAR',
    quick_terminal: 'HIZLI TERMİNAL',
    smart_scan: 'AKILLI TARAMA',
    invoice: 'Fatura',
    drafts: 'Taslaklar',
    setup_title: 'Hoşgeldin!',
    setup_subtitle: 'Profilini yapılandıralım.',
    freelancer: 'SERBEST MESLEK',
    company: 'ŞİRKET / LTD',
    firm_data: 'FİRMA BİLGİLERİ',
    continue: 'DEVAM ET',
    almost_done: 'AZ KALDI',
    ready_start: 'BAŞLAMAYA HAZIR!',
    enter_dashboard: 'DASHBOARD\'A GİR',
    iban_placeholder: 'Faturaların için IBAN',
    initiate_scan: 'Taramayı Başlat',
    release_to_scan: 'Taramak İçin Bırak',
    scan_modal_desc: 'Otomatik yapay zeka analizi için belge yükleyin.',
    camera_capture: 'Kamera',
    upload_from_device: 'Dosya Seç',
    scan_step_1: 'Sinirsel Modüller Başlatılıyor...',
    scan_step_2: 'OCR Katmanı Çıkarılıyor...',
    scan_step_3: 'Tarih ve Para Birimi Ayrıştırılıyor...',
    scan_step_4: 'Belge Kategorize Ediliyor...',
    scan_step_5: 'Kasa İçin Şifreleniyor...',
    scan_step_6: 'Sonuçlar Tamamlanıyor...',
    scan_success: 'Analiz Tamamlandı',
    scan_success_desc: 'Belge başarıyla işlendi.',
    scan_error: 'Bağlantı Başarısız',
    error_file_large: 'Dosya Çok Büyük',
    ai_active: 'YZ: Aktif',
    ready_to_scan: 'Taramaya Hazır',
    ai_analyzing: 'YZ Analiz Ediyor',
    prem_hint_2: 'Elit Tilki Ol!',
    plan_free_title: 'ÜCRETSİZ',
    plan_free_subtitle: 'Başlangıç İçin',
    plan_standard_title: 'STANDART',
    plan_standard_subtitle: 'Hırslı Kullanıcılar İçin',
    plan_pro_title: 'PRO ELİT',
    plan_pro_subtitle: 'Profesyoneller & Şirketler',
    period_forever: 'Süresiz',
    period_month: '/ Ay',
    period_year: '/ Yıl',
    monthly: 'AYLIK',
    yearly: 'YILLIK',
    select_plan: 'Planı Seç',
    feat_3_docs: '3 Belge / Ay',
    feat_basic_archive: 'Temel Arşiv',
    feat_ads: 'Reklamlı',
    feat_unlimited: 'Sınırsız Belge',
    feat_risk_radar: 'Yapay Zeka Risk Radarı',
    feat_templates: 'Tüm Şablonlar',
    feat_no_ads: 'Reklamsız',
    feat_all_included: 'Standart Dahil Her Şey',
    feat_datev: 'DATEV Dışa Aktar',
    feat_invoice_tool: 'Fatura Aracı',
    feat_priority: 'Öncelikli Destek',
    chat_system_online: 'Sistemler Çevrimiçi.',
    chat_welcome: 'Merhaba {name}! Finansal verilerinizi analiz etmeye hazırım. Ne sormak istersiniz?',
    chat_default_greeting: 'Zekam emrinize amade. Nasıl yardımcı olabilirim?',
    chat_placeholder: 'Tilkiye sor...',
    chat_connection_error: 'Bağlantı kesildi.',
    chat_retry: 'Lütfen tekrar deneyin.',
    chat_neural_link: 'SİNİRSEL BAĞ: AKTİF',
    chat_fox_intelligence: 'Fox İstihbaratı',
    analysis_title: 'FoxRadar Analizi',
    neural_engine: 'Sinirsel Motor Devrede',
    status_deductible: 'Vergiden Düşülebilir',
    status_non_deductible: 'Düşülemez',
    risk_critical: 'KRİTİK RİSK',
    risk_moderate: 'ORTA RİSK',
    risk_secure: 'GÜVENLİ / ONAYLI',
    risk_no_issues: 'Uyumluluk sorunu tespit edilmedi. Arşivleme için güvenli.',
    label_category: 'Tespit Edilen Kategori',
    category_general: 'Genel Gider',
    label_score: 'Düşülebilirlik Puanı',
    label_strategic: 'Stratejik Tavsiye',
    default_tip: 'Belge bütünlüğü doğrulandı. Arşivleme için hazır.',
    encrypted_analysis: 'Uçtan Uca Şifreli Analiz',
    trust_datacenter_title: 'ALTYAPI',
    trust_privacy_title: 'GÜVENLİK PROTOKOLÜ',
    trust_origin_title: 'MÜHENDİSLİK',
    legal_disclaimer_title: 'Yasal Uyarı',
    legal_disclaimer_subtitle: 'Uyumluluk & Danışmanlık',
    legal_disclaimer_important: 'Önemli Uyarı',
    legal_disclaimer_warning: 'BüroFuchs yapay zeka destekli bir asistandır ve profesyonel vergi veya hukuk danışmanlığının yerini tutmaz.',
    legal_disclaimer_main: 'BüroFuchs, karmaşık Alman bürokratik işlemlerini görselleştirmek ve basitleştirmek için en son teknoloji AI modellerini (Gemini 2.0 Pro) kullanır.',
    legal_disclaimer_point_1: 'Oluşturulan tüm belgeler ve bilgiler yalnızca bilgilendirme amaçlıdır.',
    legal_disclaimer_point_2: 'Sağlanan verilerin doğruluğu, eksiksizliği veya güncelliği konusunda hiçbir sorumluluk kabul etmiyoruz.',
    legal_disclaimer_point_3: 'Hukuki veya vergiyle ilgili sorularınız için her zaman yetkili bir uzmana danışın.',
    legal_scroll_unlock: 'Kilidi açmak için kaydırın',
    legal_accept: 'Kabul Et & Devam Et',
    legal_read_continue: 'Devam Etmek İçin Okuyun',
    fox_take_action: 'Aksiyon Al',
    fox_examine: 'İncele',
    fox_hint_scan: 'Hızlı tarama için buraya dokun!',
    fox_hint_chat: 'Yardım etmek için buradayım!',
    fox_hint_premium: 'Daha fazla özellik için Pro\'ya yükselt.',
    timeline_title: 'Zaman Çizelgesi',
    recent_activity: 'Son Aktiviteler',
    total_documents: 'Toplam',
    no_documents_yet: 'Henüz Belge Yok',
    system_clean: 'Sistem temiz. Yeni bir belge yükleyerek FoxRadar\'ı başlatın.',
    status_paid: 'Ödendi',
    status_unpaid: 'Ödenmedi',
    status_urgent: 'Acil',
    untitled_doc: 'Adsız Belge',
    tax_calc_title: 'Net Maaş Hesaplayıcı',
    tax_calc_desc: '2024 BMF verilerine dayalı optimize edilmiş maaş simülasyonu.',
    gross_income: 'Brüt Gelir (Yıllık)',
    tax_class: 'Vergi Sınıfı',
    tax_class_info: 'Sınıf Rehberi',
    tax_class_desc: 'Bekarlar için Sınıf 1, yüksek gelirli evliler için Sınıf 3 önerilir.',
    monthly_net: 'Aylık Net',
    yearly_net: 'Net / Yıl',
    yearly_tax: 'Vergi / Yıl',
    start_pro_analysis: 'Profesyonel Analiz Başlat',
    live_calc: 'Canlı Hesaplayıcı 2024',
    datev_uplink: 'DATEV Bağlantısı',
    datev_ready: 'Hazır',
    datev_desc: 'Mali verilerinizi Alman muhasebe standartlarına (DATEV XML) uygun olarak şifreleyip paketler.',
    btn_initiate_export: 'Dışa Aktarımı Başlat',
    btn_compiling: 'Veriler Derleniyor...',
    btn_export_complete: 'Dışa Aktarım Tamamlandı',
    btn_retry_uplink: 'Bağlantıyı Tekrar Dene',
    datev_format: 'Format: DATEV XML 7.0',
    e2ee_encrypted: 'Uçtan Uca Şifreli Paket',
    cookie_title: 'Güvenli Bağlantı',
    cookie_desc: 'Veri gizliliği önceliğimizdir. Frankfurt sunucularımızda AES-256 şifreleme ve güvenli çerezler kullanıyoruz.',
    cookie_accept: 'Protokolü Onayla',
    cookie_essential: 'Sadece Gerekli',
    cookie_badge: 'KVKK / GDPR Uyumlu',
    docu_title: 'Belge Oluşturucu',
    choose_process: 'İşlemi Seçin:',
    choose_process_desc: 'Yasal Uyumlu. DIN-5008 Standardı. Anında İndir.',
    start_protocol: 'Protokolü Başlat',
    tpl_termination: 'Fesih (Kündigung)',
    tpl_termination_desc: 'Sözleşme iptali (Mobil, Spor Salonu, Kira) için yasal mektup oluşturun.',
    tpl_objection: 'İtiraz (Widerspruch)',
    tpl_objection_desc: 'Kararlara veya faturalara karşı itiraz dilekçesi hazırlayın.',
    tpl_relocation: 'Adres Değişikliği',
    tpl_relocation_desc: 'Taşınma bildirimini resmi kurumlara ve şirketlere iletin.',
    full_name: 'Ad Soyad',
    address: 'Adres',
    recipient_label: 'Alıcı',
    recipient_placeholder: 'örn. Vodafone GmbH',
    customer_no: 'Müşteri No',
    date: 'Tarih',
    signature: 'İmza',
    clear: 'Temizle',
    waiting_input: 'Giriş Bekleniyor...',
    send_mail: 'E-Posta & İndir',
    verify_checking: 'E-posta kontrol ediliyor...',
    verify_title: 'Doğrulanıyor',
    verify_subtitle: 'BüroFuchs kimliğinizi güvenli sunucularımızda sorguluyor...',
    verify_success_title: 'Hoş Geldin,',
    verify_success_title_span: 'Kaptan!',
    verify_success_msg: 'E-posta adresiniz başarıyla onaylandı. Artık tüm özelliklere erişebilirsiniz.',
    verify_error_title: 'Bir Sorun Var',
    verify_error_msg_default: 'Bağlantı zaman aşımına uğradı veya link daha önce kullanılmış.',
    verify_missing_token: 'Doğrulama anahtarı eksik veya geçersiz.',
    verify_complete_badge: 'Doğrulama Tamamlandı',
    btn_go_dashboard: 'KONTROL PANELİNE GİT',
    btn_return_home: 'ANA SAYFAYA DÖN',
    security_protocol: 'BüroFuchs Güvenlik Protokolü v4.0',
    editor_title: 'Editör Terminali',
    editor_subtitle: 'İstihbarat Modülü v4.0',
    btn_initiate_ai: 'Yapay Zeka Otomatik Doldurmayı Başlat',
    btn_processing_ai: 'Sinir Ağı İşleniyor...',
    ai_summary_title: 'Yapay Zeka Akıllı Özeti',
    risk_detected: 'Risk Tespit Edildi',
    no_critical_risks: 'Kritik Risk Yok',
    ai_success_toast: 'Yapay Zeka Analizi Tamamlandı',
    ai_success_desc: 'Veriler akıllı algoritmalarla eşleştirildi.',
    ai_error_toast: 'Analiz Başarısız',
    ai_error_desc: 'Yapay zeka sunucusu şu an meşgul.',
    label_merchant: 'Satıcı / Başlık',
    label_amount: 'Tutar (€)',
    label_category: 'Kategori',
    label_date: 'Tarih',
    label_due_date: 'Son Ödeme Tarihi',
    label_notes: 'Detaylı Notlar',
    placeholder_notes: 'Buraya not ekleyin...',
    btn_cancel: 'İptal',
    btn_save_intelligence: 'İstihbaratı Kaydet',
    btn_saving: 'Kaydediliyor...',
    category_tax: 'Vergi',
    category_insurance: 'Sigorta',
    category_housing: 'Konut',
    category_car: 'Araç',
    category_office: 'Ofis',
    category_communication: 'İletişim',
    category_travel: 'Seyahat',
    category_advertising: 'Reklam',
    category_legal: 'Hukuk',
    category_finance: 'Finans',
    category_other: 'Diğer',
    footer_desc: 'Almanya\'daki finansal özgürlüğünüz için yeni nesil yapay zeka destekli yönetim paneli. Güvenli, Hızlı, Akıllı.',
    footer_platform: 'Platform',
    footer_resources: 'Kaynaklar',
    footer_company: 'Kurumsal',
    footer_legal: 'Gizlilik & KVKK',
    footer_impressum: 'Künye',
    footer_settings: 'Ayarlar & Abonelik',
    made_with_love: 'Frankfurt\'ta ❤️ ile yapıldı.',
    server_loc: 'Sunucu Konumu: Frankfurt (AWS EU-Central-1)',
    gdpr_compliant: 'KVKK / GDPR Uyumlu',
    welcome_title: 'Hoş Geldiniz',
    future_work: 'Çalışmanın Geleceği.',
    auth_desc: 'Almanya\'daki tüm bürokratik ve finansal süreçlerinizi tek bir akıllı merkezden yönetin.',
    welcome_back: 'Tekrar Hoş Geldiniz',
    create_account: 'Hesap Oluştur',
    login_subtitle: 'Kasanıza erişmek için bilgilerinizi girin.',
    register_subtitle: 'Ücretsiz bir hesapla yolculuğunuza başlayın.',
    label_fullname: 'Ad Soyad',
    label_email: 'E-Posta Adresi',
    label_password: 'Şifre',
    forgot_password: 'Unuttun mu?',
    btn_signin: 'Giriş Yap',
    btn_signup: 'Kaydol',
    btn_processing: 'İşleniyor...',
    or_continue: 'Veya şununla devam et',
    no_account: 'Hesabın yok mu?',
    have_account: 'Zaten hesabın var mı?',
    toast_welcome_back: 'Tekrar Hoş Geldiniz',
    toast_login_success: 'Başarıyla giriş yapıldı, yönlendiriliyorsunuz...',
    toast_register_success: 'Kayıt Başarılı',
    toast_failed: 'İşlem Başarısız',
    toast_google_success: 'Google Girişi Başarılı',
    toast_google_failed: 'Giriş Yapılamadı',
    official_procedures: 'Resmi İşlemler',
    search_procedures: 'İşlem ara...',
    fox_bureau_subtitle: 'Dijital bürokrasi asistanın. İşlemini seç.',
    ai_is_fast: 'Yapay Zeka Daha Hızlı',
    traditional: 'Geleneksel',
    slow: 'Yavaş',
    fast: 'Hızlı',
    popular_badge: 'Popüler',
    automated: 'Otomatik',
    start_process: 'İşlemi Başlat',
    tab_all: 'Tümü',
    tab_relocation: 'Taşınma',
    tab_family: 'Aile',
    tab_visa: 'Vize',
    tab_vehicle: 'Araç',
    tab_business: 'Şirket',
    proc_anmeldung_title: 'İkametgah Kaydı',
    proc_anmeldung_sub: 'Bürgeramt',
    proc_anmeldung_desc: 'Resmi adres beyanı. Taşındıktan sonra 2 hafta içinde zorunludur.',
    proc_kindergeld_title: 'Çocuk Parası',
    proc_kindergeld_sub: 'Aile Kasası',
    proc_kindergeld_desc: 'Çocuklarınız için devlet desteğine başvurun (Çocuk başına 250€).',
    proc_bluecard_title: 'AB Mavi Kart',
    proc_bluecard_sub: 'Çalışma Vizesi',
    proc_bluecard_desc: 'AB dışı ülkelerden gelen akademik personeller için oturum izni.',
    proc_kfz_title: 'Araç Tescili',
    proc_kfz_sub: 'Ruhsat İşlemleri',
    proc_kfz_desc: 'Aracınızı beklemeden kaydedin veya devredin (eVB gerekli).',
    proc_gewerbe_title: 'Ticari Sicil Kaydı',
    proc_gewerbe_sub: 'Gewerbe',
    proc_gewerbe_desc: 'İşletmenizin veya şahıs şirketinizin resmi kaydı.',
  },

  // 🇪🇸 --- ESPAÑOL (MASTER EDITION) ---
  es: {
    app_name: 'BüroFuchs',
    system_online: 'SISTEMA EN LÍNEA',
    welcome_morning: 'Buenos Días',
    welcome_day: 'Buenas Tardes',
    welcome_evening: 'Buenas Noches',
    slogan_hero: 'Tu burocracia. Simple. Digital.',
    copyright: '© 2025 BüroFuchs Digital. Hecho en Frankfurt.',
    hero_badge: 'NUEVO: IA Fiscal 2025',
    hero_title_1: 'Tus Finanzas.',
    hero_title_2: 'Automatizadas.',
    hero_desc: 'BüroFuchs gestiona tu declaración de impuestos, facturas y burocracia en Alemania. Seguro, rápido y en tu idioma.',
    cta_start_free: 'Empezar Gratis',
    cta_signup: 'Registrarse',
    download_apk: 'Descargar App',
    ecosystem_title: 'El Ecosistema',
    ecosystem_desc: 'Una plataforma para todas tus necesidades.',
    mod_tax_title: 'Declaración de Impuestos',
    mod_tax_desc: 'Reembolso máximo con ayuda de IA. Integrado con ELSTER.',
    mod_bureaucracy_title: 'Burocracia',
    mod_bureaucracy_desc: 'Autorelleno de formularios (Registro, Kindergeld).',
    mod_invoice_title: 'Facturación',
    mod_invoice_desc: 'Crea facturas profesionales en segundos.',
    mod_vault_title: 'Caja Fuerte Digital',
    mod_vault_desc: 'Todos tus documentos seguros y encriptados en un solo lugar.',
    mod_lang_title: 'Multilenguaje',
    mod_lang_desc: 'Entiende la burocracia alemana en tu idioma nativo.',
    why_us_title: '¿Por qué BüroFuchs?',
    why_us_desc: 'La comparación habla por sí sola.',
    feat_tax_refund: 'Reembolso de Impuestos',
    feat_bureaucracy: 'Trámites Oficiales',
    feat_invoice: 'Herramienta de Facturas',
    feat_salary: 'Análisis de Salario',
    feat_native_lang: 'Idioma Nativo',
    feat_archive: 'Archivo Digital',
    price_title: 'Precios',
    plan_starter: 'INICIAL',
    plan_pro: 'PRO',
    price_pay_submit: 'Pagar al Enviar',
    btn_try_free: 'Prueba Gratis',
    menu_dashboard: 'Tablero',
    menu_archive: 'Archivo Digital',
    menu_create_invoice: 'Crear Factura',
    menu_templates: 'Asistente de Cartas',
    menu_salary: 'Calculadora de Salario',
    menu_academy: 'Academia',
    menu_procedures: 'Trámites',
    menu_profile: 'Mi Perfil',
    menu_settings: 'Ajustes',
    menu_logout: 'Cerrar Sesión',
    menu_quick_scan: 'Escaneo Rápido',
    digital_hub: 'Hub Digital',
    main_control: 'Control Principal',
    security_clearance: 'Nivel de Seguridad',
    commander: 'Comandante',
    cadet_level: 'Cadete Nivel 1',
    unlimited: 'Ilimitado',
    limited_access: 'Acceso Limitado',
    upgrade: 'Mejorar',
    total_expenses: 'GASTOS TOTALES',
    refund_potential: 'POTENCIAL REEMBOLSO',
    total_documents: 'DOCUMENTOS',
    ai_efficiency: 'EFICIENCIA IA',
    live_feed: 'FEED EN VIVO',
    view_all_documents: 'VER TODO',
    recent_vault: 'CAJA FUERTE RECIENTE',
    quick_terminal: 'TERMINAL RÁPIDO',
    smart_scan: 'ESCANEO INTELIGENTE',
    invoice: 'Factura',
    drafts: 'Borradores',
    setup_title: '¡Bienvenido!',
    setup_subtitle: 'Configuremos tu perfil.',
    freelancer: 'AUTÓNOMO',
    company: 'EMPRESA / GMBH',
    firm_data: 'DATOS DE EMPRESA',
    continue: 'CONTINUAR',
    almost_done: 'CASI LISTO',
    ready_start: '¡LISTO PARA EMPEZAR!',
    enter_dashboard: 'ENTRAR AL TABLERO',
    iban_placeholder: 'IBAN para tus facturas',
    initiate_scan: 'Iniciar Escaneo',
    scan_modal_desc: 'Sube documentos para análisis automático por IA.',
    scan_success: 'Análisis Completo',
    ai_active: 'IA: Activa',
    prem_hint_2: '¡Conviértete en un Zorro de Élite!',
    plan_pro_subtitle: 'Para Profesionales y Empresas',
    chat_welcome: '¡Hola {name}! Listo para analizar tus datos financieros.',
    chat_fox_intelligence: 'Inteligencia Fox',
    analysis_title: 'Análisis FoxRadar',
    neural_engine: 'Motor Neuronal Desplegado',
    status_deductible: 'Deducible de Impuestos',
    risk_secure: 'SEGURO / VERIFICADO',
    encrypted_analysis: 'Análisis Encriptado E2EE',
    trust_datacenter_title: 'INFRAESTRUCTURA',
    legal_disclaimer_title: 'Aviso Legal',
    legal_disclaimer_warning: 'BüroFuchs es un asistente de IA y no sustituye el asesoramiento profesional.',
    official_procedures: 'Trámites Disponibles',
    proc_anmeldung_title: 'Empadronamiento (Anmeldung)',
    proc_anmeldung_desc: 'Registro oficial de dirección. Obligatorio en 2 semanas.',
    proc_kindergeld_title: 'Subsidio Familiar (Kindergeld)',
    proc_kindergeld_desc: 'Solicita ayuda estatal para tus hijos (250€ por niño).',
    proc_bluecard_title: 'Tarjeta Azul UE',
    proc_gewerbe_title: 'Registro Comercial (Gewerbe)',
    btn_cancel: 'Cancelar',
    btn_save_intelligence: 'Guardar Inteligencia',
    gdpr_compliant: 'Cumple con RGPD',
  },

  // 🇫🇷 --- FRANÇAIS (MASTER EDITION) ---
  fr: {
    app_name: 'BüroFuchs',
    system_online: 'SYSTÈME EN LIGNE',
    welcome_morning: 'Bonjour',
    welcome_day: 'Bonjour',
    welcome_evening: 'Bonsoir',
    slogan_hero: 'Votre bureaucratie. Simple. Numérique.',
    copyright: '© 2025 BüroFuchs Digital. Fait à Francfort.',
    hero_badge: 'NOUVEAU : IA Fiscale 2025',
    hero_title_1: 'Vos Finances.',
    hero_title_2: 'Automatisées.',
    hero_desc: 'BüroFuchs gère vos déclarations d\'impôts, factures et bureaucratie en Allemagne. Sécurisé, rapide et dans votre langue.',
    cta_start_free: 'Commencer Gratuitement',
    cta_signup: 'S\'inscrire',
    download_apk: 'Télécharger l\'application',
    ecosystem_title: 'L\'Écosystème',
    mod_tax_title: 'Déclaration d\'impôts',
    mod_tax_desc: 'Remboursement maximum avec l\'aide de l\'IA. Intégré à ELSTER.',
    mod_bureaucracy_title: 'Bureaucratie',
    mod_bureaucracy_desc: 'Remplissage auto des formulaires (Enregistrement, Allocations).',
    mod_invoice_title: 'Facturation',
    mod_vault_title: 'Coffre-fort Numérique',
    why_us_title: 'Pourquoi BüroFuchs ?',
    plan_starter: 'DÉBUTANT',
    plan_pro: 'PRO',
    price_pay_submit: 'Payer à la soumission',
    btn_try_free: 'Essai Gratuit',
    menu_dashboard: 'Tableau de Bord',
    menu_archive: 'Archives Numériques',
    menu_create_invoice: 'Créer une Facture',
    menu_templates: 'Assistant Courrier',
    menu_salary: 'Calculateur de Salaire',
    menu_academy: 'Académie',
    menu_procedures: 'Démarches',
    menu_profile: 'Mon Profil',
    menu_settings: 'Paramètres',
    menu_logout: 'Déconnexion',
    menu_quick_scan: 'Scan Rapide',
    digital_hub: 'Hub Numérique',
    main_control: 'Contrôle Principal',
    security_clearance: 'Habilitation de Sécurité',
    commander: 'Commandant',
    cadet_level: 'Cadet Niveau 1',
    unlimited: 'Illimité',
    limited_access: 'Accès Limité',
    upgrade: 'Mettre à niveau',
    total_expenses: 'DÉPENSES TOTALES',
    refund_potential: 'POTENTIEL DE REMBOURSEMENT',
    total_documents: 'DOCUMENTS',
    ai_efficiency: 'EFFICACITÉ IA',
    live_feed: 'FLUX EN DIRECT',
    smart_scan: 'SCAN INTELLIGENT',
    invoice: 'Facture',
    setup_title: 'Bienvenue !',
    setup_subtitle: 'Configurons votre profil.',
    freelancer: 'FREELANCE',
    company: 'ENTREPRISE / GMBH',
    firm_data: 'DONNÉES SOCIÉTÉ',
    ready_start: 'PRÊT À COMMENCER !',
    enter_dashboard: 'ACCÉDER AU TABLEAU DE BORD',
    initiate_scan: 'Lancer le Scan',
    scan_modal_desc: 'Téléchargez des documents pour une analyse IA automatique.',
    scan_success: 'Analyse Terminée',
    ai_active: 'IA : Active',
    chat_welcome: 'Bonjour {name} ! Prêt à analyser vos données financières.',
    chat_fox_intelligence: 'Intelligence Fox',
    analysis_title: 'Analyse FoxRadar',
    neural_engine: 'Moteur Neuronal Déployé',
    status_deductible: 'Déductible d\'impôts',
    risk_secure: 'SÉCURISÉ / VÉRIFIÉ',
    encrypted_analysis: 'Analyse Chiffrée E2EE',
    legal_disclaimer_title: 'Avis Juridique',
    legal_disclaimer_warning: 'BüroFuchs est un assistant IA et ne remplace pas un conseil fiscal ou juridique professionnel.',
    official_procedures: 'Procédures Disponibles',
    proc_anmeldung_title: 'Enregistrement (Anmeldung)',
    proc_anmeldung_desc: 'Enregistrement officiel de l\'adresse. Obligatoire sous 2 semaines.',
    proc_kindergeld_title: 'Allocations Familiales (Kindergeld)',
    proc_kindergeld_desc: 'Demandez l\'aide de l\'État pour vos enfants (250€ par enfant).',
    proc_bluecard_title: 'Carte Bleue UE',
    proc_gewerbe_title: 'Enregistrement Commercial (Gewerbe)',
    gdpr_compliant: 'Conforme RGPD',
    btn_save_intelligence: 'Sauvegarder l\'Intelligence',
  },

  // 🇮🇹 --- ITALIANO (MASTER EDITION) ---
  it: {
    app_name: 'BüroFuchs',
    system_online: 'SISTEMA ONLINE',
    welcome_morning: 'Buongiorno',
    welcome_day: 'Buon Pomeriggio',
    welcome_evening: 'Buonasera',
    slogan_hero: 'La tua burocrazia. Semplice. Digitale.',
    copyright: '© 2025 BüroFuchs Digital. Fatto a Francoforte.',
    hero_badge: 'NUOVO: Tasse IA 2025',
    hero_title_1: 'Le tue Finanze.',
    hero_title_2: 'Automatizzate.',
    hero_desc: 'BüroFuchs gestisce la tua dichiarazione dei redditi, fatture e burocrazia in Germania. Sicuro, veloce e nella tua lingua.',
    cta_start_free: 'Inizia Gratis',
    cta_signup: 'Registrati',
    mod_tax_title: 'Dichiarazione dei Redditi',
    mod_tax_desc: 'Rimborso massimo con l\'aiuto dell\'IA. Integrato con ELSTER.',
    mod_bureaucracy_title: 'Burocrazia',
    mod_invoice_title: 'Fatturazione',
    mod_vault_title: 'Cassaforte Digitale',
    plan_starter: 'STARTER',
    plan_pro: 'PRO',
    btn_try_free: 'Prova Gratuita',
    menu_dashboard: 'Dashboard',
    menu_archive: 'Archivio Digitale',
    menu_create_invoice: 'Crea Fattura',
    menu_templates: 'Assistente Lettere',
    menu_salary: 'Calcolatore Stipendio',
    menu_academy: 'Accademia',
    menu_procedures: 'Procedure',
    menu_profile: 'Il Mio Profilo',
    menu_settings: 'Impostazioni',
    menu_logout: 'Esci',
    menu_quick_scan: 'Scansione Rapida',
    digital_hub: 'Hub Digitale',
    main_control: 'Controllo Principale',
    security_clearance: 'Livello di Sicurezza',
    commander: 'Comandante',
    cadet_level: 'Cadetto Livello 1',
    unlimited: 'Illimitato',
    limited_access: 'Accesso Limitato',
    upgrade: 'Aggiorna',
    total_expenses: 'SPESE TOTALI',
    refund_potential: 'POTENZIALE RIMBORSO',
    total_documents: 'DOCUMENTI',
    ai_efficiency: 'EFFICIENZA IA',
    live_feed: 'FEED LIVE',
    smart_scan: 'SCANSIONE SMART',
    invoice: 'Fattura',
    setup_title: 'Benvenuto!',
    setup_subtitle: 'Configuriamo il tuo profilo.',
    freelancer: 'LIBERO PROFESSIONISTA',
    company: 'AZIENDA / GMBH',
    firm_data: 'DATI AZIENDALI',
    ready_start: 'PRONTO A PARTIRE!',
    enter_dashboard: 'ENTRA NELLA DASHBOARD',
    initiate_scan: 'Avvia Scansione',
    scan_success: 'Analisi Completata',
    ai_active: 'IA: Attiva',
    chat_welcome: 'Ciao {name}! Pronto ad analizzare i tuoi dati finanziari.',
    chat_fox_intelligence: 'Intelligenza Fox',
    analysis_title: 'Analisi FoxRadar',
    neural_engine: 'Motore Neurale Attivo',
    status_deductible: 'Deducibile',
    risk_secure: 'SICURO / VERIFICATO',
    encrypted_analysis: 'Analisi Crittografata E2EE',
    official_procedures: 'Procedure Disponibili',
    proc_anmeldung_title: 'Registrazione Residenza (Anmeldung)',
    proc_anmeldung_desc: 'Registrazione ufficiale dell\'indirizzo. Obbligatoria entro 2 settimane.',
    proc_kindergeld_title: 'Assegni Familiari (Kindergeld)',
    proc_kindergeld_desc: 'Richiedi il sostegno statale per i tuoi figli (250€ per figlio).',
    proc_bluecard_title: 'Carta Blu UE',
    proc_gewerbe_title: 'Registrazione Commerciale (Gewerbe)',
    legal_disclaimer_warning: 'BüroFuchs è un assistente IA e non sostituisce la consulenza professionale fiscale o legale.',
    gdpr_compliant: 'Conforme GDPR',
  },

  // 🇵🇱 --- POLSKI (MASTER EDITION) ---
  pl: {
    app_name: 'BüroFuchs',
    system_online: 'SYSTEM ONLINE',
    welcome_morning: 'Dzień Dobry',
    welcome_day: 'Dzień Dobry',
    welcome_evening: 'Dobry Wieczór',
    slogan_hero: 'Twoja biurokracja. Prosta. Cyfrowa.',
    copyright: '© 2025 BüroFuchs Digital. Made in Frankfurt.',
    hero_badge: 'NOWOŚĆ: Podatki AI 2025',
    hero_title_1: 'Twoje Finanse.',
    hero_title_2: 'Zautomatyzowane.',
    hero_desc: 'BüroFuchs zajmie się Twoim zeznaniem podatkowym, fakturami i biurokracją w Niemczech. Bezpiecznie, szybko i w Twoim języku.',
    cta_start_free: 'Rozpocznij za Darmo',
    cta_signup: 'Zarejestruj się',
    mod_tax_title: 'Deklaracja Podatkowa',
    mod_tax_desc: 'Maksymalny zwrot z pomocą AI. Zintegrowane z ELSTER.',
    mod_bureaucracy_title: 'Biurokracja',
    mod_invoice_title: 'Fakturowanie',
    mod_vault_title: 'Cyfrowy Sejf',
    plan_starter: 'STARTER',
    plan_pro: 'PRO',
    btn_try_free: 'Wypróbuj za Darmo',
    menu_dashboard: 'Pulpit',
    menu_archive: 'Archiwum Cyfrowe',
    menu_create_invoice: 'Wystaw Fakturę',
    menu_templates: 'Asystent Pism',
    menu_salary: 'Kalkulator Płac',
    menu_academy: 'Akademia',
    menu_procedures: 'Sprawy Urzędowe',
    menu_profile: 'Mój Profil',
    menu_settings: 'Ustawienia',
    menu_logout: 'Wyloguj',
    menu_quick_scan: 'Szybki Skan',
    digital_hub: 'Centrum Cyfrowe',
    main_control: 'Główne Sterowanie',
    security_clearance: 'Poziom Bezpieczeństwa',
    commander: 'Dowódca',
    cadet_level: 'Kadet Poziom 1',
    unlimited: 'Nieograniczony',
    limited_access: 'Dostęp Ograniczony',
    upgrade: 'Ulepsz',
    total_expenses: 'WYDATKI CAŁKOWITE',
    refund_potential: 'POTENCJALNY ZWROT',
    total_documents: 'DOKUMENTY',
    ai_efficiency: 'WYDAJNOŚĆ AI',
    live_feed: 'KANAŁ NA ŻYWO',
    smart_scan: 'INTELIGENTNY SKAN',
    invoice: 'Faktura',
    setup_title: 'Witaj!',
    setup_subtitle: 'Skonfigurujmy Twój profil.',
    freelancer: 'FREELANCER',
    company: 'FIRMA / GMBH',
    firm_data: 'DANE FIRMY',
    ready_start: 'GOTOWY DO STARTU!',
    enter_dashboard: 'WEJDŹ DO PULPITU',
    official_procedures: 'Dostępne Procedury',
    proc_anmeldung_title: 'Meldunek (Anmeldung)',
    proc_anmeldung_desc: 'Oficjalne zameldowanie adresu. Obowiązkowe w ciągu 2 tygodni.',
    proc_kindergeld_title: 'Zasiłek Rodzinny (Kindergeld)',
    proc_kindergeld_desc: 'Złóż wniosek o wsparcie państwowe dla dzieci (250€ na dziecko).',
    proc_bluecard_title: 'Niebieska Karta UE',
    proc_gewerbe_title: 'Rejestracja Działalności (Gewerbe)',
    chat_welcome: 'Cześć {name}! Gotowy do analizy Twoich danych finansowych.',
    chat_fox_intelligence: 'Inteligencja Fox',
    analysis_title: 'Analiza FoxRadar',
    status_deductible: 'Odliczalne od podatku',
    risk_secure: 'BEZPIECZNE / ZWERYFIKOWANE',
    legal_disclaimer_warning: 'BüroFuchs to asystent AI i nie zastępuje profesjonalnej porady podatkowej ani prawnej.',
    gdpr_compliant: 'Zgodność z RODO',
  },

  // 🇷🇺 --- РУССКИЙ (MASTER EDITION) ---
  ru: {
    app_name: 'BüroFuchs',
    system_online: 'СИСТЕМА ОНЛАЙН',
    welcome_morning: 'Доброе утро',
    welcome_day: 'Добрый день',
    welcome_evening: 'Добрый вечер',
    slogan_hero: 'Ваша бюрократия. Просто. В цифровом виде.',
    copyright: '© 2025 BüroFuchs Digital. Сделано во Франкфурте.',
    hero_badge: 'НОВИНКА: AI Налоги 2025',
    hero_title_1: 'Ваши финансы.',
    hero_title_2: 'Автоматизировано.',
    hero_desc: 'BüroFuchs занимается вашей налоговой декларацией, счетами и бюрократией в Германии. Безопасно, быстро и на вашем языке.',
    cta_start_free: 'Начать бесплатно',
    cta_signup: 'Регистрация',
    mod_tax_title: 'Налоговая декларация',
    mod_tax_desc: 'Максимальный возврат с помощью ИИ. Интеграция с ELSTER.',
    mod_bureaucracy_title: 'Бюрократия',
    mod_invoice_title: 'Счета',
    mod_vault_title: 'Цифровой сейф',
    plan_starter: 'СТАРТ',
    plan_pro: 'ПРО',
    btn_try_free: 'Попробовать бесплатно',
    menu_dashboard: 'Панель управления',
    menu_archive: 'Цифровой архив',
    menu_create_invoice: 'Создать счет',
    menu_templates: 'Помощник писем',
    menu_salary: 'Калькулятор зарплаты',
    menu_academy: 'Академия',
    menu_procedures: 'Процедуры',
    menu_profile: 'Мой профиль',
    menu_settings: 'Настройки',
    menu_logout: 'Выйти',
    menu_quick_scan: 'Быстрый скан',
    digital_hub: 'Цифровой Хаб',
    main_control: 'Главное управление',
    security_clearance: 'Уровень безопасности',
    commander: 'Командир',
    cadet_level: 'Кадет Уровень 1',
    unlimited: 'Безлимитно',
    limited_access: 'Ограниченный доступ',
    upgrade: 'Обновить',
    total_expenses: 'ОБЩИЕ РАСХОДЫ',
    refund_potential: 'ПОТЕНЦИАЛ ВОЗВРАТА',
    total_documents: 'ДОКУМЕНТЫ',
    ai_efficiency: 'ЭФФЕКТИВНОСТЬ ИИ',
    live_feed: 'ЛЕНТА',
    smart_scan: 'УМНЫЙ СКАН',
    invoice: 'Счет',
    setup_title: 'Добро пожаловать!',
    setup_subtitle: 'Давайте настроим ваш профиль.',
    freelancer: 'ФРИЛАНСЕР',
    company: 'КОМПАНИЯ / GMBH',
    firm_data: 'ДАННЫЕ ФИРМЫ',
    ready_start: 'ГОТОВ К ЗАПУСКУ!',
    enter_dashboard: 'ВОЙТИ В ПАНЕЛЬ',
    official_procedures: 'Доступные процедуры',
    proc_anmeldung_title: 'Регистрация (Anmeldung)',
    proc_anmeldung_desc: 'Официальная регистрация адреса. Обязательно в течение 2 недель.',
    proc_kindergeld_title: 'Детское пособие (Kindergeld)',
    proc_kindergeld_desc: 'Подайте заявку на господдержку для детей (250€ на ребенка).',
    proc_bluecard_title: 'Голубая карта ЕС',
    proc_gewerbe_title: 'Регистрация бизнеса (Gewerbe)',
    chat_welcome: 'Привет, {name}! Готов к анализу ваших финансовых данных.',
    chat_fox_intelligence: 'Интеллект Fox',
    analysis_title: 'Анализ FoxRadar',
    status_deductible: 'Налоговый вычет',
    risk_secure: 'БЕЗОПАСНО / ПРОВЕРЕНО',
    encrypted_analysis: 'E2EE Шифрованный анализ',
    legal_disclaimer_warning: 'BüroFuchs — это ИИ-ассистент, не заменяющий профессиональную налоговую или юридическую консультацию.',
    gdpr_compliant: 'Соответствует GDPR',
  },

  // 🇸🇦 --- العربية (MASTER EDITION) ---
  sa: {
    app_name: 'BüroFuchs',
    system_online: 'النظام متصل',
    welcome_morning: 'صباح الخير',
    welcome_day: 'طاب يومك',
    welcome_evening: 'مساء الخير',
    slogan_hero: 'بيروقراطيتك. بسيطة. رقمية.',
    copyright: '© 2025 BüroFuchs Digital. صنع في فرانكفورت.',
    hero_badge: 'جديد: الذكاء الاصطناعي للضرائب 2025',
    hero_title_1: 'ماليتك.',
    hero_title_2: 'مؤتمتة.',
    hero_desc: 'BüroFuchs يتولى إقرارك الضريبي، فواتيرك، والبيروقراطية في ألمانيا. آمن، سريع، وبلغتك.',
    cta_start_free: 'ابدأ مجاناً',
    cta_signup: 'تسجيل الدخول',
    download_apk: 'تحميل التطبيق',
    mod_tax_title: 'الإقرار الضريبي',
    mod_tax_desc: 'أقصى استرداد بمساعدة الذكاء الاصطناعي. متكامل مع ELSTER.',
    mod_bureaucracy_title: 'البيروقراطية',
    mod_invoice_title: 'الفواتير',
    mod_vault_title: 'الخزنة الرقمية',
    plan_starter: 'بداية',
    plan_pro: 'محترف',
    btn_try_free: 'جرب مجاناً',
    menu_dashboard: 'لوحة القيادة',
    menu_archive: 'الأرشيف الرقمي',
    menu_create_invoice: 'إنشاء فاتورة',
    menu_templates: 'مساعد الخطابات',
    menu_salary: 'حاسبة الراتب',
    menu_academy: 'الأكاديمية',
    menu_procedures: 'الإجراءات الرسمية',
    menu_profile: 'ملفي الشخصي',
    menu_settings: 'الإعدادات',
    menu_logout: 'تسجيل الخروج',
    menu_quick_scan: 'مسح سريع',
    digital_hub: 'المركز الرقمي',
    main_control: 'التحكم الرئيسي',
    security_clearance: 'التصريح الأمني',
    commander: 'قائد',
    cadet_level: 'متدرب مستوى 1',
    unlimited: 'غير محدود',
    limited_access: 'وصول محدود',
    upgrade: 'ترقية',
    total_expenses: 'إجمالي المصروفات',
    refund_potential: 'احتمال الاسترداد',
    total_documents: 'المستندات',
    ai_efficiency: 'كفاءة الذكاء الاصطناعي',
    live_feed: 'البث المباشر',
    smart_scan: 'مسح ذكي',
    invoice: 'فاتورة',
    setup_title: 'مرحباً!',
    setup_subtitle: 'لنقم بإعداد ملفك الشخصي.',
    freelancer: 'عمل حر',
    company: 'شركة / GmbH',
    firm_data: 'بيانات الشركة',
    ready_start: 'جاهز للانطلاق!',
    enter_dashboard: 'دخول لوحة القيادة',
    official_procedures: 'الإجراءات المتاحة',
    proc_anmeldung_title: 'تسجيل السكن (Anmeldung)',
    proc_anmeldung_desc: 'تسجيل العنوان الرسمي. إلزامي خلال أسبوعين.',
    proc_kindergeld_title: 'إعانة الطفل (Kindergeld)',
    proc_kindergeld_desc: 'قدم طلب للحصول على دعم حكومي لأطفالك (250 يورو لكل طفل).',
    proc_bluecard_title: 'البطاقة الزرقاء للاتحاد الأوروبي',
    proc_gewerbe_title: 'التسجيل التجاري (Gewerbe)',
    chat_welcome: 'مرحباً {name}! مستعد لتحليل بياناتك المالية.',
    chat_fox_intelligence: 'ذكاء الثعلب',
    analysis_title: 'تحليل FoxRadar',
    status_deductible: 'قابل للخصم الضريبي',
    risk_secure: 'آمن / تم التحقق',
    encrypted_analysis: 'تحليل مشفر E2EE',
    legal_disclaimer_warning: 'BüroFuchs هو مساعد ذكاء اصطناعي وليس بديلاً عن المشورة الضريبية أو القانونية المهنية.',
    gdpr_compliant: 'متوافق مع اللائحة العامة لحماية البيانات (GDPR)',
  },
};

// ==============================================================================
// AKILLI ÇEVİRİ YÖNETİCİSİ (FALLBACK ENGINE v2.0)
// ==============================================================================

/**
 * Gelişmiş Çeviri Getirici
 * Zincirleme geri dönüş mekanizması (Fallback Chain):
 * 1. Hedef Dil -> 2. İngilizce (Global) -> 3. Almanca (Kök) -> 4. Anahtar ID
 */
export const getTranslation = (language, key) => {
  const langData = translations[language];

  // 1. Hedef Dilde Tam Eşleşme
  if (langData && langData[key]) {
    return langData[key];
  }

  // 2. Global İngilizce Fallback
  if (language !== 'en' && translations['en'] && translations['en'][key]) {
    return translations['en'][key];
  }

  // 3. Sistem Kökü Almanca Fallback
  if (language !== 'de' && translations['de'] && translations['de'][key]) {
    return translations['de'][key];
  }

  // 4. Fallback: Anahtarın kendisi
  return key; 
};